import { handleErrors, localConfig, combineUrl, getCurrentLang, getToken, handleProfileTokenExpired, handleCheckSession, getCacheUserInfo, getErrorParams } from '~/common';
import { exceptionLog } from '~/client';

const headers = new Headers({
    "Content-Type": "application/json; charset=utf-8",
    //"language": (localStorage.getItem('language') || navigator.language || "en-us").toLowerCase(),
});

const fileHeaders = new Headers({
    "Content-Type": "application/octet-stream; charset=utf-8",
});
const init = { method: "Post", mode: "cors", headers: headers, credentials: 'include' };
const fileInit = { method: "Post", mode: "cors", headers: fileHeaders, credentials: 'include' };

function parseJson(text, apiUrl) {
    try {
        return JSON.parse(text);
    } catch (ex) {
        console.error('parse api response json error', ex, text, apiUrl);
        const params = getErrorParams(ex, JSON.stringify({
            text,
            apiUrl,
            href: window.location.href,
            stack: ex.stack,
        }, null, 4));
        exceptionLog(params);
        return { status: -1, msg: 'invalid json response' };
    }
}

export default function request(url, data, callback, { needValidAccessToken = true, interceptors, file, trans, aid } = {}) {
    const token = getToken();
    if (needValidAccessToken && !token) {
        try {
            handleErrors({ status: 401 });
        }
        catch (ex) {
            const error = new Error('No Access Token');
            error.code = 401;
            const rs = { status: -1, Status: -1, msg: error.message, Msg: error.message };
            typeof callback === 'function' && callback(error, rs);
            return Promise.resolve(rs);
        }
    }
    let newInit;
    if (file) {
        newInit = Object.assign({}, fileInit, { body: data instanceof FormData ? data : JSON.stringify(data) });
    } else {
        newInit = Object.assign({}, init, { body: data instanceof FormData ? data : JSON.stringify(data) });
    }

    if (data instanceof FormData) {
        newInit.headers.delete('Content-Type');
    } else {
        newInit.headers.set('Content-Type', 'application/json; charset=utf-8');
    }
    needValidAccessToken && newInit.headers.set('Authorization', `Bearer ${token}`);
    trans && newInit.headers.set('trans', trans);
    newInit.headers.set('language', getCurrentLang());
    if (aid) {
        newInit.headers.set('aid', aid);
    } else {
        const userInfo = getCacheUserInfo();
        userInfo && userInfo.aid && newInit.headers.set('aid', userInfo.aid);
    }
    localConfig.obtApiVersion && newInit.headers.set('version', localConfig.obtApiVersion);
    if (!/https?/i.test(url)) {
        url = combineUrl(localConfig.obtApiUrl, url);
    }
    url = url + `${url.indexOf('?') > -1 ? '&' : '?'}_r=${Math.random()}`;
    let requestInit = new Request(url, newInit);
    if (interceptors && typeof interceptors.request == 'function') {
        interceptors.request(requestInit);
    }
    let promise = handleCheckSession().then(() => fetch(requestInit))
        .then(res => interceptors && typeof interceptors.response == 'function' ? interceptors.response(res) : handleErrors(res))
        .then(async function (response) {
            const contentType = (response.headers.get('Content-Type') || '').split(';')[0];
            if (contentType === 'application/json') {
                return response.json();
            } else if (contentType === 'application/octet-stream' || contentType === 'application/pdf') {
                const blob = await response.blob();

                return blob;
            } else {
                let jsonText = await response.text();
                return jsonText ? parseJson(jsonText, url) : { status: -1, msg: 'empty response' };
            }
        }).then(function (rs) {
            if (handleProfileTokenExpired(rs)) return;
            typeof callback === 'function' && callback(null, rs, requestInit);
            return Promise.resolve(rs);
        }).catch(function (ex) {
            typeof callback === 'function' && callback(ex, null, requestInit);
            return Promise.reject(ex);
        });
    return promise;
}

